import { useAuth } from '@schooly/components/authentication';
import { SchoolUserRole } from '@schooly/constants';
import { useSchoolProperties } from '@schooly/hooks/use-school-properties';
import { useMemo } from 'react';

import { getFormStatuses } from '../utils';

export const useSchoolTuneStatuses = () => {
  const { schoolId = '', currentSchool } = useAuth();

  const { propertiesMap: studentPropertiesMap, isLoading: isLoadingStudentProperties } =
    useSchoolProperties({ schoolId, userType: SchoolUserRole.Student }, { enabled: !!schoolId });

  const { propertiesMap: staffPropertiesMap, isLoading: isLoadingStaffProperties } =
    useSchoolProperties({ schoolId, userType: SchoolUserRole.Staff }, { enabled: !!schoolId });

  const [formStudentStatuses, formStaffStatuses] = useMemo(() => {
    return [
      getFormStatuses(studentPropertiesMap.status),
      getFormStatuses(staffPropertiesMap.status),
    ];
  }, [studentPropertiesMap.status, staffPropertiesMap.status]);

  return {
    currentSchool,
    schoolId,
    formStudentStatuses,
    formStaffStatuses,
    isLoading: isLoadingStudentProperties || isLoadingStaffProperties,
  };
};
